import { groupModel } from 'APP/model/model';

export async function addGroupAdmins(
  groupId: string,
  userIds: string[]
): Promise<{ error: string | null }> {
  try {
    await groupModel.addGroupAdmins({ groupId, userIds });

    return { error: null };
  } catch (error) {
    return { error: error.message };
  }
}
